// extracted by mini-css-extract-plugin
module.exports = {"SignInContainer":"SignIn_SignInContainer__3QQl6","AuthLogo":"SignIn_AuthLogo__EMr9s"};